var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.5 14a.75.75 0 0 0 0-1.5zm-15-.75H.75c0 .414.336.75.75.75zM2.25.75a.75.75 0 0 0-1.5 0zm13 1.25H16a.75.75 0 0 0-.75-.75zM9 8.25l-.53.53a.75.75 0 0 0 1.06 0zm-2.5-2.5.53-.53a.75.75 0 0 0-1.06 0zM.97 10.22a.75.75 0 1 0 1.06 1.06zM14.5 5.125a.75.75 0 0 0 1.5 0zM12.125 1.25a.75.75 0 0 0 0 1.5zM16.5 12.5h-15V14h15zm-14.25.75V.75H.75v12.5zM14.72 1.47 8.47 7.72l1.06 1.06 6.25-6.25zM9.53 7.72l-2.5-2.5-1.06 1.06 2.5 2.5zm-3.56-2.5-5 5 1.06 1.06 5-5zM16 5.125V2h-1.5v3.125zm-.75-3.875h-3.125v1.5h3.125z"
  })));
};
export default SvgActivity;